<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset *ngIf="!isInstaMed()" formGroupName="legalEntity">
    <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
      <label class="col-md-8 control-label" for="merchantLegalName">
        Name
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="merchantLegalName"
          id="merchantLegalName"
          formControlName="merchantName"
          [ngClass]="{
            'is-invalid':
              legalEntityFormControls.merchantName.invalid &&
              (legalEntityFormControls.merchantName.dirty ||
                legalEntityFormControls.merchantName.touched)
          }"
        />
        <div
          *ngIf="
            legalEntityFormControls.merchantName.invalid &&
            (legalEntityFormControls.merchantName.dirty ||
              legalEntityFormControls.merchantName.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="legalEntityFormControls.merchantName.errors?.required"
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="legalEntityFormControls.merchantName.errors?.maxlength"
          >
            Content is too long. Please shorten it.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalEntityPhoneNumber">
        Phone Number
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="legalEntityPhoneNumber"
          id="legalEntityPhoneNumber"
          formControlName="phoneNumber"
          [ngClass]="{
            'is-invalid':
              legalEntityFormControls.phoneNumber.invalid &&
              (legalEntityFormControls.phoneNumber.dirty ||
                legalEntityFormControls.phoneNumber.touched)
          }"
        />
        <div
          *ngIf="
            legalEntityFormControls.phoneNumber.invalid &&
            (legalEntityFormControls.phoneNumber.dirty ||
              legalEntityFormControls.phoneNumber.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="legalEntityFormControls.phoneNumber.errors?.pattern"
          >
            Phone number must be 10 digits.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalAddressLine1">
        Address Line 1
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="legalAddressLine1"
          id="legalAddressLine1"
          formControlName="legalAddressLine1"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalAddressLine2">
        Address Line 2
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="legalAddressLine2"
          id="legalAddressLine2"
          formControlName="legalAddressLine2"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalCity"> City </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="legalCity"
          id="legalCity"
          formControlName="legalCity"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalState"> State </label>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-8">
            <select
              class="form-control"
              name="legalState"
              id="legalState"
              formControlName="legalState"
            >
              <option value="">--- Select State ---</option>
              <option
                *ngFor="let state of states | keyvalue"
                [value]="state.key"
              >
                {{ state.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalZip"> Zip </label>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              name="legalZip"
              id="legalZip"
              formControlName="legalZip"
              [ngClass]="{
                'is-invalid':
                  legalEntityFormControls.legalZip.invalid &&
                  (legalEntityFormControls.legalZip.dirty ||
                    legalEntityFormControls.legalZip.touched)
              }"
            />
          </div>
          <div
            class="mt-1"
            *ngIf="
              legalEntityFormControls.legalZip.invalid &&
              legalEntityFormControls.legalZip.touched
            "
          >
            <div
              class="text-danger"
              *ngIf="legalEntityFormControls.legalZip.errors?.pattern"
            >
              Invalid Zip, must be a number.
            </div>
            <div
              class="text-danger"
              *ngIf="legalEntityFormControls.legalZip.errors?.maxlength"
            >
              Max length is 11.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="legalCountry"> Country </label>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-8">
            <select
              class="form-control"
              name="legalCountry"
              id="legalCountry"
              formControlName="legalCountry"
            >
              <option value="">--- Select Country ---</option>
              <option
                *ngFor="let country of countries | keyvalue"
                [value]="country.key"
              >
                {{ country.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
